import React, {Component} from 'react'
import HttpClient from "../../utils/HttpClient/HttpClient";
import MaterialIcon from "material-icons-react";
import {Checkbox, Col} from "react-bootstrap";

export default class TopWidgetComponent extends Component {

    httpClient;
    constructor(props){
        super(props);
        this.state = { checked: false, };
        this.httpClient = new HttpClient(true);
    }
    componentWillMount(){
        this.httpClient.get(`oga/dashboard/widget/${this.props.id}`).then((response) => {
            this.setState({ checked: response.data }); })
            .catch((error) => {
                console.error("oga/dashboard/widget error", error);
            });
    }

    render() {
        return (
            <div>
                {
                    this.props.isDashboard ?
                        <Col md={12} className="no-padding no-margin">
                            <div className="widget-from-input-container flex-row">

                                <span>{this.props.label}</span>

                                <div className="vertical-center- space">
                                    <div className="w-form-line" />
                                </div>
                                <div className="form-check cursor"
                                     onClick={() => {this.props.onSelectionChange(false, this.props.id) } }>
                                    <MaterialIcon icon="close"/>
                                </div>
                            </div>
                        </Col> :
                        <div className="widget-from-input-container flex-row">
                            <span>{this.props.label}</span>
                            <div className="vertical-center- space">
                                <div className="w-form-line " />
                            </div>
                            <div className="form-check">
                                <small className="widget-add-dashboard">Agregar al dashboard</small>
                                <Checkbox
                                    checked={this.state.checked}
                                    onChange={(b) => {
                                        let checked = this.cb.checked;
                                        this.props.onSelectionChange(checked, this.props.id);
                                        this.setState({ checked: checked});
                                    }}
                                    inputRef={ref => this.cb = ref}
                                    className="float-right" />
                            </div>
                        </div>
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Widgets/TopWidgetComponent.jsx